'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Request = undefined;

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('d2-utilizr/lib/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isEmpty = require('d2-utilizr/lib/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Request = exports.Request = undefined;

exports.Request = Request = function Request(refs, config) {
    var t = this;

    config = (0, _isObject2.default)(config) ? config : {};

    // constructor
    t.method = (0, _isString2.default)(config.method) ? config.method : 'GET';
    t.headers = (0, _isObject2.default)(config.headers) ? config.headers : refs.appManager.defaultRequestHeaders;
    t.dataType = (0, _isString2.default)(config.dataType) ? config.dataType : 'json';
    t.contentType = (0, _isString2.default)(config.contentType) ? config.contentType : null;
    t.success = (0, _isFunction2.default)(config.success) ? config.success : function () {
        t.defaultSuccess();
    };
    t.error = (0, _isFunction2.default)(config.error) ? config.error : function () {
        t.defaultError();
    };
    t.complete = (0, _isFunction2.default)(config.complete) ? config.complete : function () {
        t.defaultComplete();
    };

    t.type = (0, _isString2.default)(config.type) ? config.type : 'ajax';
    t.baseUrl = (0, _isString2.default)(config.baseUrl) ? config.baseUrl : '';
    t.params = (0, _arrayFrom2.default)(config.params);
    t.data = config.data ? config.data : null;
    t.manager = config.manager || null;

    t.beforeRun = (0, _isFunction2.default)(config.beforeRun) ? config.beforeRun : null;
    t.afterRun = (0, _isFunction2.default)(config.afterRun) ? config.afterRun : null;

    // defaults
    t.defaultSuccess = function () {
        var t = this;

        if (t.manager) {
            t.manager.ok(t);
        }
    };

    t.defaultError = function () {};
    t.defaultComplete = function () {};
};

Request.prototype.log = function (text, noError) {
    if (!noError) {
        console.log(text, this);
    }
};

Request.prototype.alert = function (text, noError) {
    if (!noError) {
        alert(text);
    }
};

Request.prototype.handle = function (statusCode, noError) {
    var url = this.url(),
        text;

    if ((0, _arrayContains2.default)([413, 414], statusCode)) {
        if (isIE()) {
            text = 'Too many items selected (url has ' + url.length + ' characters). Internet Explorer accepts maximum 2048 characters.';
        } else {
            var len = url.length > 8000 ? '8000' : url.length > 4000 ? '4000' : '2000';
            text = 'Too many items selected (url has ' + url.length + ' characters). Please reduce to less than ' + len + ' characters.';
        }
    }

    if (text) {
        text += '\n\n' + 'Hint: A good way to reduce the number of items is to use relative periods and level/group organisation unit selection modes.';

        this.alert(text);
    }
};

Request.prototype.add = function (param) {
    var t = this;

    if ((0, _isString2.default)(param)) {
        t.params.push(param);
    } else if ((0, _isArray2.default)(param)) {
        param.forEach(function (item) {
            if ((0, _isString2.default)(item)) {
                t.params.push(item);
            }
        });
    } else if ((0, _isObject2.default)(param)) {
        for (var key in param) {
            if (param.hasOwnProperty(key) && !(0, _isEmpty2.default)(param[key])) {
                t.params.push(key + '=' + param[key]);
            }
        }
    }

    return this;
};

Request.prototype.setBaseUrl = function (baseUrl) {
    if ((0, _isString2.default)(baseUrl)) {
        this.baseUrl = baseUrl;
    }
};

Request.prototype.setType = function (type) {
    if ((0, _isString2.default)(type)) {
        this.type = type;
    }
};

Request.prototype.setManager = function (manager) {
    this.manager = manager;
};

Request.prototype.setSuccess = function (fn) {
    if ((0, _isFunction2.default)(fn)) {
        this.success = fn;
    }
};

Request.prototype.setError = function (fn) {
    if ((0, _isFunction2.default)(fn)) {
        this.error = fn;
    }
};

Request.prototype.setBeforeRun = function (fn) {
    if ((0, _isFunction2.default)(fn)) {
        this.beforeRun = fn;
    }
};

Request.prototype.setComplete = function (fn) {
    if ((0, _isFunction2.default)(fn)) {
        this.complete = fn;
    }
};

Request.prototype.url = function (extraParams) {
    var params = (0, _arrayClean2.default)([].concat(this.params, (0, _arrayFrom2.default)(extraParams)));

    return this.baseUrl + (params.length ? '?' + params.join('&') : '');
};

// dep 1

Request.prototype.run = function (config) {
    var t = this,
        url = encodeURI(this.url());

    config = (0, _isObject2.default)(config) ? config : {};

    var success = config.success || t.success,
        error = config.error || t.error,
        complete = config.complete || t.complete;

    var completeFn = function completeFn() {
        if ((0, _isFunction2.default)(t.afterRun)) {
            t.afterRun();
        }

        complete();
    };

    if (t.beforeRun && t.beforeRun() === false) {
        return;
    }

    if (t.type === 'json') {
        return $.getJSON(url, success).error(error).complete(complete);
    } else {
        var method = config.method || t.method,
            headers = config.headers || t.headers,
            dataType = config.dataType || t.dataType,
            contentType = config.contentType || t.contentType,
            data = config.data || t.data,
            xhr = {};

        xhr.url = url;
        xhr.method = method;
        xhr.type = method;
        xhr.data = data;
        headers && (xhr.headers = headers);
        dataType && (xhr.dataType = dataType);
        contentType && (xhr.contentType = contentType);
        xhr.success = success;
        xhr.error = error;
        xhr.complete = completeFn;

        return $.ajax(xhr);
    }
};
//# sourceMappingURL=Request.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/Request.js
 ** module id = 114
 ** module chunks = 0 1
 **/